import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import { Smile } from "lucide-react";
import { useEditorRef } from "platejs/react";
import { memo, useCallback, useState } from "react";
import { cn } from "../../tailwind-utils";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";

interface EmojiData {
  native: string;
}

export const EmojiToolbarButton = memo(function EmojiToolbarButton() {
  const editor = useEditorRef();
  const [open, setOpen] = useState(false);

  const handleSelect = useCallback(
    (emoji: EmojiData) => {
      editor.tf.insertText(emoji.native);
      editor.tf.focus();
      setOpen(false);
    },
    [editor],
  );

  return (
    <Popover modal={false} onOpenChange={setOpen} open={open}>
      <PopoverTrigger asChild>
        <button
          className={cn(
            "inline-flex h-8 min-w-8 cursor-pointer items-center justify-center rounded-md px-1.5",
            "hover:bg-muted hover:text-muted-foreground",
            "[&_svg:not([class*='size-'])]:size-4",
          )}
          type="button"
        >
          <Smile />
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        className="w-auto border-none p-0 shadow-none"
      >
        <Picker
          data={data}
          onEmojiSelect={handleSelect}
          previewPosition="none"
          skinTonePosition="none"
          theme="light"
        />
      </PopoverContent>
    </Popover>
  );
});
